var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LearnMore"},[_c('cld-image',{staticClass:"learnmore-icon",attrs:{"public-id":"v1557870041/state_of_visual_media/cloudinary-finger.svg","alt":"Tooltip indicator"}}),_c('strong',[_vm._v("LEARN MORE")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }